var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yufajingjiang-page"},[_c('navBar',{on:{"goBack":_vm.goBack}},[_c('span',{staticClass:"title"},[_vm._v("写作指导")])]),_c('textImgContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }